import Header from '../header/header'
import './home.css'
import Dashboard from './dashboard'
import ResetPassword from '../../login/resetPassword';
import { deleteToken } from '../../utils/util'
import QuestionLibrary from '../questionLibrary/questionLibrary'
import Membership from '../membership/membership'
import EmailScheduler from '../emailScheduler/emailScheduler'
import AuditLog from '../auditLog/auditLog'
import ErrorLog from '../errorLog/errorLog'
import MockTests from '../mocktest/mocktests'
import CreateMockTest from '../create-mocktest/createMockTest'
import ManagePlans from '../plans/ManagePlans'
import Broadcast from '../broadcast/Broadcast'

/* ── sidebar icons (from Modernist handoff) ── */
const ic = {
  dashboard: <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="7" height="9" x="3" y="3" rx="1"/><rect width="7" height="5" x="14" y="3" rx="1"/><rect width="7" height="9" x="14" y="12" rx="1"/><rect width="7" height="5" x="3" y="16" rx="1"/></svg>,
  mock: <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="8" height="4" x="8" y="2" rx="1"/><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/><path d="m9 14 2 2 4-4"/></svg>,
  ql: <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 7v14"/><path d="M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z"/></svg>,
  membership: <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>,
  plans: <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 12V7H5a2 2 0 0 1 0-4h14v4"/><path d="M3 5v14a2 2 0 0 0 2 2h16v-5"/><path d="M18 12a2 2 0 0 0 0 4h4v-4Z"/></svg>,
  broadcast: <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m3 11 18-5v12L3 14v-3z"/><path d="M11.6 16.8a3 3 0 1 1-5.8-1.6"/></svg>,
  audit: <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/><path d="m9 12 2 2 4-4"/></svg>,
  error: <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" x2="12" y1="8" y2="12"/><line x1="12" x2="12.01" y1="16" y2="16"/></svg>,
  logout: <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" x2="9" y1="12" y2="12"/></svg>,
}

const NavItem = ({ icon, label, active, onClick }) => (
  <div
    className="tyk-nav"
    onClick={onClick}
    style={active ? {
      background: 'var(--color-accent-100)',
      borderLeftColor: 'var(--color-accent)',
      color: 'var(--color-accent)',
    } : undefined}
  >
    {icon}{label}
  </div>
)

const SectionLabel = ({ children, first }) => (
  <div style={{
    fontSize: 10, letterSpacing: '.12em', textTransform: 'uppercase',
    color: 'var(--color-neutral-500)', padding: first ? '0 16px 8px' : '16px 16px 8px',
  }}>{children}</div>
)

const Home = () => {
  const loc = document.location.href.replace(/\/+$/, "")
  const keysUrl = loc.split('/')
  let pos = ""
  if (keysUrl.length > 3) {
    pos = keysUrl[3]
  }
  const go = (path) => () => { document.location.href = path }
  const logout = () => { deleteToken(); document.location.href = "/login" }

  const isActive = (id) => pos === id || (id === "dashboard" && (pos === "" || pos === "home"))

  return (
    <div style={{ display: 'flex', height: '100vh', overflow: 'hidden', background: 'var(--color-bg)' }}>

      {/* SIDEBAR */}
      <aside style={{ width: 238, flex: 'none', background: 'var(--color-neutral-100)', borderRight: '2px solid var(--color-divider)', display: 'flex', flexDirection: 'column', overflowY: 'auto' }}>
        <div style={{ height: 64, flex: 'none', display: 'flex', alignItems: 'center', padding: '0 20px', borderBottom: '2px solid var(--color-divider)' }}>
          <div style={{ width: 30, height: 30, background: 'var(--color-accent)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--color-bg)', fontFamily: 'var(--font-heading)', fontWeight: 800, fontSize: 15, marginRight: 10 }}>T</div>
          <div style={{ fontFamily: 'var(--font-heading)', fontWeight: 800, fontSize: 17, letterSpacing: '-0.01em', whiteSpace: 'nowrap' }}>TYK<span className="text-muted" style={{ fontWeight: 800 }}> Admin</span></div>
        </div>
        <div style={{ padding: '14px 0 8px', flex: 1 }}>
          <SectionLabel first>Overview</SectionLabel>
          <NavItem icon={ic.dashboard} label="Dashboard" active={isActive('dashboard')} onClick={go('/dashboard')} />
          <SectionLabel>Content</SectionLabel>
          <NavItem icon={ic.mock} label="Mock Tests" active={isActive('mock-test')} onClick={go('/mock-test')} />
          <NavItem icon={ic.ql} label="Question Library" active={isActive('question-library')} onClick={go('/question-library')} />
          <SectionLabel>Commerce</SectionLabel>
          <NavItem icon={ic.membership} label="Membership" active={isActive('membership')} onClick={go('/membership')} />
          <NavItem icon={ic.plans} label="Manage Plans" active={isActive('manage-plans')} onClick={go('/manage-plans')} />
          <NavItem icon={ic.broadcast} label="Broadcast" active={isActive('broadcast')} onClick={go('/broadcast')} />
          <SectionLabel>System</SectionLabel>
          <NavItem icon={ic.audit} label="Audit Log" active={isActive('audit-log')} onClick={go('/audit-log')} />
          <NavItem icon={ic.error} label="Error Log" active={isActive('error-log')} onClick={go('/error-log')} />
        </div>
        <div style={{ borderTop: '2px solid var(--color-divider)', padding: 12 }}>
          <div className="tyk-nav" onClick={logout} style={{ padding: '10px 12px', color: 'var(--color-neutral-700)', borderLeft: 'none' }}>
            {ic.logout}Logout
          </div>
        </div>
      </aside>

      {/* MAIN */}
      <main style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
        <Header title={pos} />
        <div style={{ flex: 1, overflowY: 'auto', padding: 28 }}>
          {
            pos === "" || pos === "home" || pos === "dashboard" ? <Dashboard /> :
            pos === "reset-password" ? <ResetPassword /> :
            pos === "create-mocktest" ? <CreateMockTest /> :
            pos === "mock-test" ? <MockTests /> :
            pos === "manage-plans" ? <ManagePlans /> :
            pos === "broadcast" ? <Broadcast /> :
            pos === "question-library" ? <QuestionLibrary /> :
            pos === "membership" ? <Membership /> :
            pos === "email-scheduler" ? <EmailScheduler /> :
            pos === "audit-log" ? <AuditLog /> :
            pos === "error-log" ? <ErrorLog /> : ''
          }
        </div>
      </main>
    </div>
  )
}
export default Home
